import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=4ffe7eeb"
var script = {}
import style0 from "./SocialButtons.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/vercel/path0/components/Base/Icon/BaseIcon.vue').default})
